module.exports = __webpack_public_path__ + "static/media/flyrest-4.af587981.jpg";